import { Component, input, model, ModelSignal } from '@angular/core';

@Component({
  selector: 'app-toggle',
  standalone: true,
  templateUrl: './toggle.component.html',
  styleUrls: ['./toggle.component.scss']
})
export class ToggleComponent {

  readonly leftLabel = input('Off');
  readonly rightLabel = input('On');

  toggleState: ModelSignal<boolean | string> = model<boolean | string>(false);

  // Perus toggle-metodi (voit edelleen käyttää sitä esimerkiksi napin klikkauksessa)
  toggle(): void {
    this.toggleState.update(current =>
        typeof current === 'boolean'
            ? !current
            : current === this.leftLabel()
                ? this.rightLabel()
                : this.leftLabel()
    );
  }

  // Asettaa tilan vasemmalle (leftLabel tai boolean false)
  selectLeft(): void {
    if (typeof this.toggleState() === 'boolean') {
      this.toggleState.set(false);
    } else {
      this.toggleState.set(this.leftLabel());
    }
  }

  // Asettaa tilan oikealle (rightLabel tai boolean true)
  selectRight(): void {
    if (typeof this.toggleState() === 'boolean') {
      this.toggleState.set(true);
    } else {
      this.toggleState.set(this.rightLabel());
    }
  }

  // Palauttaa nykyisen tilan
  getState(): boolean | string {
    return this.toggleState();
  }
}
